import { render, staticRenderFns } from "./PersonnelRecordEditTabContact.vue?vue&type=template&id=3dbf58ba"
import script from "./PersonnelRecordEditTabContact.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports